import { useMemo } from "react";

import type { IAggregatedEvent } from "~/types/event";
import { formatDate } from "~/utils/formatDate";

export const useEventDateRange = (event: IAggregatedEvent) => {
  const dateRange = useMemo(() => {
    if (!event.startDate && !event.endDate) return null;
    const start = event.startDate
      ? formatDate(event.startDate, { includeYear: true })
      : "";
    const end = event.endDate
      ? formatDate(event.endDate, { includeYear: true })
      : "";
    if (!start && !end) return null;
    return `${start}${start && end ? " - " : ""}${end}`;
  }, [event.startDate, event.endDate]);

  return dateRange;
};
